import Dialog from "ui/elements/dialog/Dialog";
import {i18n} from "ui/i18n";
import guideView from "./guide.handlebars";
import Template from "ui/Template";
import {STATIC_URL} from "ui/config";

export default class Guide extends Dialog {
	constructor() {
		super({
			title: i18n('title.guide'),
			width: 1024
		});

		this.setContent(new Template(guideView).createElement({
			static_url: STATIC_URL
		}));
	}
}
